"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6346],{

/***/ 53680:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _ScrollableStack = _interopRequireDefault(__webpack_require__(50902));
var _Container = _interopRequireDefault(__webpack_require__(58709));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Theme = __webpack_require__(86522);
var _useHover = _interopRequireDefault(__webpack_require__(68854));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var defaultProps = {
  titleAs: "h3"
};
var CardsSlider = function CardsSlider(props) {
  var children = props.children,
    title = props.title,
    _props$titleAs = props.titleAs,
    titleAs = _props$titleAs === void 0 ? defaultProps.titleAs : _props$titleAs,
    itemsVisible = props.itemsVisible,
    itemsGap = props.itemsGap,
    buttonArrowLeft = props.buttonArrowLeft,
    buttonArrowRight = props.buttonArrowRight;
  var theme = (0, _Theme.useTheme)();
  var gap = itemsGap ? itemsGap : theme.space.gridGap;
  var margin = theme.space.containerMargin;
  var rootRef = (0, _react.useRef)(null);
  var rootHovered = (0, _useHover["default"])(rootRef);
  return __jsx(_Box["default"], {
    _ref: rootRef
  }, __jsx(_Container["default"], null, __jsx(_Box["default"], {
    as: titleAs,
    sx: {
      font: "label",
      mb: "s8"
    }
  }, title)), __jsx(_Container["default"], {
    margin: [0, null, "containerMargin"]
  }, __jsx(_ScrollableStack["default"], {
    sx: {
      width: "100%",
      $itemsVisible: itemsVisible ? itemsVisible : [1.5, null, 3, null, 4],
      $gap: gap,
      $innerMargin: [margin[0], null, 0] // TODO: in commerce-ui update we'll allow for ["containerMargin", null, 0] syntax.
    },
    previousButton: function previousButton(_ref) {
      var isAtStart = _ref.isAtStart;
      return {
        button: /*#__PURE__*/_react["default"].cloneElement(buttonArrowLeft, {
          sx: {
            opacity: !rootHovered || isAtStart ? 0 : 1,
            transition: "opacity .15s",
            pointerEvents: !rootHovered || isAtStart ? "none" : "default"
          }
        }),
        offset: -22
      };
    },
    nextButton: function nextButton(_ref2) {
      var isAtEnd = _ref2.isAtEnd;
      return {
        button: /*#__PURE__*/_react["default"].cloneElement(buttonArrowRight, {
          sx: {
            opacity: !rootHovered || isAtEnd ? 0 : 1,
            transition: "opacity .15s",
            pointerEvents: !rootHovered || isAtEnd ? "none" : "default"
          }
        }),
        offset: -22
      };
    }
  }, children)));
};
var _default = CardsSlider;
exports.Z = _default;

/***/ }),

/***/ 58109:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _RouteContext = __webpack_require__(73157);
var __jsx = _react["default"].createElement;
var CategorySubmenu = function CategorySubmenu(props) {
  var _submenu$subcategorie;
  var submenu = props.submenu,
    _props$underlineAsAct = props.underlineAsActive,
    underlineAsActive = _props$underlineAsAct === void 0 ? false : _props$underlineAsAct,
    _props$hasNoChildren = props.hasNoChildren,
    hasNoChildren = _props$hasNoChildren === void 0 ? false : _props$hasNoChildren;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var isSale = submenu.special && submenu.special === "sale";
  var hasNoSubcategories = ((_submenu$subcategorie = submenu.subcategories) === null || _submenu$subcategorie === void 0 ? void 0 : _submenu$subcategorie.length) === 0;
  return __jsx(_Box["default"], {
    as: "ul",
    key: "fragment-" + submenu.name,
    sx: {
      width: "180px",
      mb: hasNoChildren ? "s5" : hasNoSubcategories ? "s6" : "s9"
    }
  }, __jsx(_Box["default"], {
    as: "li",
    sx: {
      font: hasNoChildren ? "s_sans" : "base_sans_bold",
      color: isSale ? "negative" : "main",
      textDecoration: underlineAsActive ? "underline" : "none",
      "&:hover": {
        textDecoration: hasNoChildren ? "underline" : "none"
      },
      mb: hasNoChildren ? 0 : "s6"
    }
  }, __jsx(Link, {
    route: "category-page",
    params: submenu
  }, __jsx(_LinkRaw["default"], {
    title: submenu.name
  }, submenu.name))), __jsx(_Box["default"], null, submenu.subcategories && Object.keys(submenu.subcategories).map(function (item, index) {
    return __jsx(_Box["default"], {
      as: "ul",
      key: "submenuLinks-" + index,
      sx: {
        width: "180px"
      }
    }, __jsx(_Box["default"], {
      as: "li",
      sx: {
        font: "s_sans",
        color: "main",
        mt: "s5",
        width: "180px",
        "&:hover": {
          textDecoration: "underline"
        }
      },
      key: submenu.subcategories[item].url
    }, __jsx(Link, {
      route: "category-page",
      params: submenu.subcategories[item]
    }, __jsx(_LinkRaw["default"], {
      title: submenu.subcategories[item].name
    }, submenu.subcategories[item].name))));
  })));
};
var _default = CategorySubmenu;
exports.Z = _default;

/***/ }),

/***/ 50444:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ButtonAmbitionBack = exports.ButtonArrowAmbitionRight = exports.ButtonArrowAmbitionLeft = exports.ButtonArrowProRight = exports.ButtonArrowProLeft = exports.ButtonArrowBigRight = exports.ButtonArrowBigLeft = exports.ButtonArrowRight = exports.ButtonArrowLeft = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _ButtonIcon = _interopRequireDefault(__webpack_require__(7859));
var _core = __webpack_require__(79329);
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconChevronLeft = function IconChevronLeft(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.952 12.748l8.133-8.495-.866-.83-8.92 9.316 8.915 9.51.876-.821-8.138-8.68z"
  }));
};
IconChevronLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconChevronRight = function IconChevronRight(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.436 12.748L7.303 4.253l.867-.83 8.92 9.316-8.916 9.51-.875-.821 8.137-8.68z"
  }));
};
IconChevronRight.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconArrowLeft = function IconArrowLeft(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), __jsx("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
  }));
};
IconArrowLeft.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
var IconArrowRight = function IconArrowRight(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), __jsx("path", {
    d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
  }));
};
IconArrowRight.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
var sharedStyles = {
  overflow: "hidden",
  borderRadius: "22px",
  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.15)",
  ":focus": {
    outline: 0
  },
  "::-moz-focus-inner": {
    border: 0
  },
  $background: function $background(_ref) {
    var isHovered = _ref.isHovered;
    return {
      bg: "white",
      opacity: 1,
      transition: "opacity .15s"
    };
  },
  $body: {
    color: "main"
  }
};
var ButtonArrow = (0, _core.createComponent)(_ButtonIcon["default"], _objectSpread({
  height: "44px",
  width: "44px"
}, sharedStyles));
var ButtonArrowPro = (0, _core.createComponent)(_ButtonIcon["default"], {
  height: "42px",
  width: "42px",
  overflow: "hidden",
  borderRadius: "22px",
  boxShadow: "1px 1px 2px 0px rgba(0,0,0,0.3)",
  ":focus": {
    outline: 0
  },
  "::-moz-focus-inner": {
    border: 0
  },
  $background: function $background(_ref2) {
    var isHovered = _ref2.isHovered;
    return {
      bg: isHovered ? "mono200" : "white",
      opacity: 1,
      transition: "opacity .15s"
    };
  },
  $body: {
    color: "main"
  }
});
var ButtonArrowAmbition = (0, _core.createComponent)(_ButtonIcon["default"], {
  height: "40px",
  width: "40px",
  overflow: "hidden",
  borderRadius: "22px",
  $background: function $background(_ref3) {
    var isHovered = _ref3.isHovered;
    return {
      bg: isHovered ? "main" : "darkGrey",
      transition: "opacity .15s"
    };
  },
  $body: {
    color: "white"
  }
});
var ButtonArrowBack = (0, _core.createComponent)(_ButtonIcon["default"], {
  height: "40px",
  pl: "16px",
  pr: "24px",
  overflow: "hidden",
  borderRadius: "60px",
  $background: function $background(_ref4) {
    var isHovered = _ref4.isHovered;
    return {
      bg: isHovered ? "veryLightGray" : "grayBg",
      transition: "opacity .15s"
    };
  },
  $body: {
    color: "main"
  }
});
var ButtonArrowBig = (0, _core.createComponent)(_ButtonIcon["default"], _objectSpread(_objectSpread({
  height: "55px",
  width: "55px"
}, sharedStyles), {}, {
  borderRadius: "55px"
}));
var ButtonArrowLeft = function ButtonArrowLeft(props) {
  return __jsx(ButtonArrow, props, __jsx(IconChevronLeft, null));
};
exports.ButtonArrowLeft = ButtonArrowLeft;
var ButtonArrowRight = function ButtonArrowRight(props) {
  return __jsx(ButtonArrow, props, __jsx(IconChevronRight, null));
};
exports.ButtonArrowRight = ButtonArrowRight;
var ButtonArrowBigLeft = function ButtonArrowBigLeft(props) {
  return __jsx(ButtonArrowBig, props, __jsx(IconChevronLeft, null));
};
exports.ButtonArrowBigLeft = ButtonArrowBigLeft;
var ButtonArrowBigRight = function ButtonArrowBigRight(props) {
  return __jsx(ButtonArrowBig, props, __jsx(IconChevronRight, null));
};
exports.ButtonArrowBigRight = ButtonArrowBigRight;
var ButtonArrowProLeft = function ButtonArrowProLeft(props) {
  return __jsx(ButtonArrowPro, props, __jsx(IconArrowLeft, null));
};
exports.ButtonArrowProLeft = ButtonArrowProLeft;
var ButtonArrowProRight = function ButtonArrowProRight(props) {
  return __jsx(ButtonArrowPro, props, __jsx(IconArrowRight, null));
};
exports.ButtonArrowProRight = ButtonArrowProRight;
var ButtonArrowAmbitionLeft = function ButtonArrowAmbitionLeft(props) {
  return __jsx(ButtonArrowAmbition, props, __jsx(IconArrowLeft, null));
};
exports.ButtonArrowAmbitionLeft = ButtonArrowAmbitionLeft;
var ButtonArrowAmbitionRight = function ButtonArrowAmbitionRight(props) {
  return __jsx(ButtonArrowAmbition, props, __jsx(IconArrowRight, null));
};
exports.ButtonArrowAmbitionRight = ButtonArrowAmbitionRight;
var ButtonAmbitionBack = function ButtonAmbitionBack(props) {
  return __jsx(ButtonArrowBack, props, __jsx(IconArrowLeft, null), props.children);
};
exports.ButtonAmbitionBack = ButtonAmbitionBack;

/***/ }),

/***/ 75561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_CardsSlider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53680);
/* harmony import */ var _deosite_components_new_buttons_ButtonArrow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50444);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CardsSlider = function(props) {
    var propsExt = _objectSpread({}, props, {
        buttonArrowLeft: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_ButtonArrow__WEBPACK_IMPORTED_MODULE_3__.ButtonArrowLeft, {}),
        buttonArrowRight: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_ButtonArrow__WEBPACK_IMPORTED_MODULE_3__.ButtonArrowRight, {})
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_CardsSlider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, propsExt)));
};
/* harmony default export */ __webpack_exports__["Z"] = (CardsSlider);


/***/ }),

/***/ 84749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56410);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prismic_reactjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98290);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40300);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58709);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _commerce_ui_core2_LinkRaw__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88244);
/* harmony import */ var _commerce_ui_core2_LinkRaw__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_LinkRaw__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_ProductBox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87122);
/* harmony import */ var _components_RectangleCardWithLabelBoxInside__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62999);
/* harmony import */ var _components_CardsSlider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75561);
/* harmony import */ var _deosite_components_new_CategorySubmenu__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58109);
/* harmony import */ var _containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73764);
/* harmony import */ var _sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44553);
/* harmony import */ var _deosite_api_hooks_common_useAnalytics4AndCommerceTags__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79892);
/* harmony import */ var _deosite_api_hooks_common_LanguageProvider__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8989);
/* harmony import */ var _deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51493);
/* harmony import */ var _deosite_helpers_getDefaultProductImage__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(705);
/* harmony import */ var _deosite_lib_RouteContext__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(73157);










 // TODO: przerobic import







var CategoryPage = function(props) {
    var ref, ref1, ref2;
    var subcategoryForLeftColumn = props.subcategoryForLeftColumn, categoryProducts = props.categoryProducts, currentCategory = props.currentCategory, parentCategory = props.parentCategory, backLabel = props.backLabel, backClickFunction = props.backClickFunction, footerContent = props.footerContent, pagination = props.pagination, filtersBar = props.filtersBar, categoriesSliderMobile = props.categoriesSliderMobile, dataRequiredToHideLoader = props.dataRequiredToHideLoader, prismicData = props.prismicData, categoryBanner = props.categoryBanner, _filtersString = props.filtersString, filtersString = _filtersString === void 0 ? "" : _filtersString, _isDefaultView = props.isDefaultView, isDefaultView = _isDefaultView === void 0 ? true : _isDefaultView, _externalHtml = props.externalHtml, externalHtml = _externalHtml === void 0 ? "" : _externalHtml, _totalCount = props.totalCount, totalCount = _totalCount === void 0 ? "" : _totalCount, _isSearchPage = props.isSearchPage, isSearchPage = _isSearchPage === void 0 ? false : _isSearchPage;
    var language = (0,_deosite_api_hooks_common_LanguageProvider__WEBPACK_IMPORTED_MODULE_14__.useLanguage)().language;
    var Link = (0,_deosite_lib_RouteContext__WEBPACK_IMPORTED_MODULE_17__.useRouteContext)().Link;
    var translations = {
        seoDescription: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_15__["default"])("Default seo description"),
        seoTitle: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_15__["default"])("Default seo title")
    };
    var viewList = (0,_deosite_api_hooks_common_useAnalytics4AndCommerceTags__WEBPACK_IMPORTED_MODULE_13__["default"])().viewList;
    var isFirstRun = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            viewList(categoryProducts, currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name, isSearchPage ? "search_results" : "category", isSearchPage ? "search" : "category-" + (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name.replace(" ", "-")));
        }
    });
    var products = categoryProducts.map(function(product, index) {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductBox__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            product: product,
            otherDefaultImage: (0,_deosite_helpers_getDefaultProductImage__WEBPACK_IMPORTED_MODULE_16__.getDefaultCategoryProductImage)(__webpack_require__.g.__appConfig__.categoryDefaultImage, language === null || language === void 0 ? void 0 : language.language, product),
            parentListType: isSearchPage ? "search" : "category",
            parentListIndex: index
        }, index);
    });
    categoryBanner && products.splice(categoryBanner.position - 1, 0, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_RectangleCardWithLabelBoxInside__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        link: categoryBanner.url ? categoryBanner.url : " ",
        label: categoryBanner.text,
        image: categoryBanner.image
    }, "saleBox"));
    var descriptionBox = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
        children: (prismicData === null || prismicData === void 0 ? void 0 : (ref = prismicData.content) === null || ref === void 0 ? void 0 : ref.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
            sx: {
                mt: "s12"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                    sx: {
                        borderTop: "1px",
                        borderTopColor: "neutral500",
                        borderStyle: "solid",
                        height: "1px"
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                    sx: {
                        font: "base",
                        color: "main",
                        pt: "s9",
                        pb: "s9",
                        h5: {
                            font: "l",
                            pt: "0px",
                            pb: "0px",
                            m: "0px"
                        },
                        ul: {
                            mb: "s0"
                        },
                        p: {
                            my: "s7"
                        },
                        a: {
                            color: "main",
                            fontWeight: 700
                        }
                    },
                    children: prismic_reactjs__WEBPACK_IMPORTED_MODULE_2__.RichText.render((ref1 = prismicData.content) === null || ref1 === void 0 ? void 0 : ref1.description.content)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                    sx: {
                        borderTop: "1px",
                        borderTopColor: "neutral500",
                        borderStyle: "solid",
                        height: "1px"
                    }
                })
            ]
        })
    });
    var rightColumn = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                sx: {
                    mb: "s9"
                },
                children: categoriesSliderMobile
            }),
            filtersBar,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                sx: {
                    mb: "s9"
                },
                children: pagination
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_3___default()), {
                cols: [
                    2,
                    2,
                    3,
                    3
                ],
                sx: {
                    gridRowGap: "s11",
                    mt: "s7"
                },
                children: products
            })
        ]
    });
    var subcategoriesHaveNoChildren = true;
    subcategoryForLeftColumn === null || subcategoryForLeftColumn === void 0 ? void 0 : subcategoryForLeftColumn.find(function(category) {
        if (category.subcategories.length > 0) {
            subcategoriesHaveNoChildren = false;
        }
    });
    var displayCurrentCategoryName = true;
    subcategoryForLeftColumn === null || subcategoryForLeftColumn === void 0 ? void 0 : subcategoryForLeftColumn.find(function(category) {
        if (category.id === currentCategory.id) {
            displayCurrentCategoryName = false;
        }
    });
    var parentCategoryHeaderData = displayCurrentCategoryName ? currentCategory : parentCategory;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        footerContent: footerContent,
        products: products,
        returnLinkLabel: backLabel,
        onReturnLabelClick: backClickFunction,
        metaTagsData: {
            description: translations.seoDescription,
            title: translations.seoTitle
        },
        dataRequiredToHideLoader: dataRequiredToHideLoader,
        externalIntegrationsHtml: externalHtml.length > 0 ? externalHtml : "",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            title: (currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name) ? "".concat(filtersString, " ").concat(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name, " (").concat(totalCount, ")") : filtersString,
            children: isDefaultView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                sx: {
                    mt: [
                        "s9",
                        0,
                        null
                    ]
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default()), {
                    children: [
                        filtersBar,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                            sx: {
                                mt: "s3",
                                mb: "s9"
                            },
                            children: pagination
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                            "data-test": "product-container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    cols: [
                                        2,
                                        2,
                                        4,
                                        4
                                    ],
                                    children: products
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    sx: {
                                        mt: "s12"
                                    },
                                    children: pagination
                                }),
                                pagination.props.currentPage === 1 && descriptionBox
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                        sx: {
                            mb: "s9"
                        },
                        children: (prismicData === null || prismicData === void 0 ? void 0 : (ref2 = prismicData.content) === null || ref2 === void 0 ? void 0 : ref2.tiles) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CardsSlider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            itemsGap: "16px",
                            itemsVisible: [
                                1.5,
                                null,
                                3,
                                null,
                                5
                            ],
                            children: prismicData.content.tiles.map(function(tile, index) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_RectangleCardWithLabelBoxInside__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    link: tile.url,
                                    label: tile.title,
                                    image: tile.image,
                                    promoLabel: tile.promoLabel
                                }, index);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_5___default()), {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_3___default()), {
                                cols: [
                                    24,
                                    null,
                                    null,
                                    20
                                ],
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        sx: {
                                            gridColumnStart: 1,
                                            gridColumnEnd: 5,
                                            gridRowStart: "row1-start",
                                            gridRowEnd: 2,
                                            display: [
                                                "none",
                                                null,
                                                null,
                                                "grid"
                                            ]
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            children: [
                                                subcategoriesHaveNoChildren && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                    sx: {
                                                        font: "base_sans_bold",
                                                        mb: "s6",
                                                        color: "main"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Link, {
                                                        route: "category-page",
                                                        params: {
                                                            url: parentCategoryHeaderData.url
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_LinkRaw__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                            title: parentCategoryHeaderData.name,
                                                            children: parentCategoryHeaderData.name
                                                        })
                                                    })
                                                }),
                                                subcategoryForLeftColumn === null || subcategoryForLeftColumn === void 0 ? void 0 : subcategoryForLeftColumn.map(function(subcategory) {
                                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_CategorySubmenu__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                        underlineAsActive: subcategoriesHaveNoChildren && subcategory.id === currentCategory.id,
                                                        hasNoChildren: subcategoriesHaveNoChildren,
                                                        submenu: subcategory
                                                    });
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        sx: {
                                            gridColumnStart: [
                                                1,
                                                null,
                                                null,
                                                5,
                                                null
                                            ],
                                            gridColumnEnd: [
                                                25,
                                                null,
                                                null,
                                                21
                                            ],
                                            gridRowStart: "row6-start",
                                            gridRowEnd: 2
                                        },
                                        children: rightColumn
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_4___default()), {
                                sx: {
                                    mt: "s12"
                                },
                                children: pagination
                            }),
                            pagination.props.currentPage === 1 && descriptionBox
                        ]
                    })
                ]
            })
        })
    }, currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name));
};
/* harmony default export */ __webpack_exports__["default"] = (CategoryPage);


/***/ })

}]);